import styles from "./ColumnsSelector.module.scss"
import ActionMenuButtonsRow from "./../Widgets/ActionMenuButtonsRow";
import _ from "lodash";
import React, { useState, useEffect, useMemo } from "react";
import { ClickAway, DisableScroll } from "./../Functional";
import ActionMenuCheckbox from "./../Widgets/ActionMenuCheckbox"
import classNames from "classnames";

const ColumnsSelector = React.forwardRef(({isSticky, originalColumns, columnState, restoreColumnStateDefaults, updateColumnState, closeSelector, className}, ref) => {
    const getColumnSelection = () => {
        return _.mapValues(columnState, column => {
            if (column.mustShow) return false;
            return column.isHidden;
        });
    }
    const [columnSelection, setColumnSelection] = useState(getColumnSelection());
    const [checkAll, setCheckAll] = useState(false);
    const columns = useMemo(() => {
        // Hiding column from column selection is not recommended. This should be removed in the future releases.
        return _.reject(originalColumns, "hideFromColumnSelector");
    }, [originalColumns])
    const columnsMap = _.keyBy(originalColumns, "id");
    const handleSelectAll = () => {
        setCheckAll(prev => !prev)
        setColumnSelection(_.mapValues(columnState, column => {
            if (column.mustShow) return false;
            return checkAll;
        }));
    }

    useEffect(() => {
        setColumnSelection(getColumnSelection());
    }, [columnState]);

    useEffect(() => {
        if (_.isEmpty(columnSelection)) {
            setCheckAll(false);
            return;
        }
        const keys = _.keys(columnSelection);
        let isAllChecked = true;
        for (let i = 0; i < keys.length; i++) {
            if (columnSelection[keys[i]]) {
                //if any of the column is not selected (hidden = true)
                isAllChecked = false;
                break;
            }
        }
        setCheckAll(isAllChecked);
    }, [columnSelection]);

    return <div className={classNames(styles.base, className)} ref={ref}>
        <ClickAway ignoreParentClick={true} listener={closeSelector}/>
        {isSticky && <DisableScroll/>}
        <div className={styles.content}>
            <ActionMenuCheckbox className={styles["select-all"]} onChange={ handleSelectAll } checked={checkAll} isPartial={!checkAll}>{`All (${columns.length})`}</ActionMenuCheckbox>
            {_.map(columns, ({id}) => {
                return <ActionMenuCheckbox
                    disabled={columnsMap[id].mustShow}
                    key={id}
                    onChange={() => {
                        setColumnSelection({ ...columnSelection, [id]: !columnSelection[id] });
                    }}
                    className={styles["disabled-and-checked"]}
                    checked={!columnSelection[id]}>
                    {columnsMap[id].header}
                </ActionMenuCheckbox>
            })}
        </div>
        <ActionMenuButtonsRow>
            <button type="button" onClick={() => {
                const newColumnState = { ...columnState };
                _.forEach(columnSelection, (isHidden, id) => {
                    newColumnState[id] = { ...columnState[id], isHidden }
                })
                updateColumnState(newColumnState);
                closeSelector();
            }}>Apply</button>
            <button type="button" onClick={() => {
                restoreColumnStateDefaults();
                closeSelector();
            }}>Restore Defaults</button>
        </ActionMenuButtonsRow>
    </div>
})

export default ColumnsSelector;
